/**
 * Impressão / PDF do report OS v2 via clone + window.print (sem html2canvas/jsPDF).
 *
 * Contrato:
 * - cloneNode do #os-report-v2-print-root (mesmo DOM/CSS da preview)
 * - flag data-print-os-report-v2 no body
 * - @media print esconde o resto da UI
 * - window.print() → diálogo nativo (PDF / impressora)
 * - A4 retrato forçado via <style> injetado (vence @page landscape de outros módulos)
 */

const PRINT_FLAG = 'data-print-os-report-v2';
const WRAPPER_ID = 'os-report-v2-print-wrapper';
const STYLE_ID = 'os-report-v2-print-page-style';

const PRINT_PAGE_CSS = `
@media print {
  @page {
    size: A4 portrait;
    margin: 0;
  }
  @page os-report-v2 {
    size: A4 portrait;
    margin: 0;
  }
}
`;

function cleanupPrintOsReportV2() {
  if (typeof document === 'undefined') return;
  document.body.removeAttribute(PRINT_FLAG);
  const w = document.getElementById(WRAPPER_ID);
  if (w) w.remove();
  const s = document.getElementById(STYLE_ID);
  if (s) s.remove();
}

export function printOsReportV2(rootEl) {
  if (!rootEl || typeof document === 'undefined') return;

  cleanupPrintOsReportV2();

  let styleEl = document.getElementById(STYLE_ID);
  if (!styleEl) {
    styleEl = document.createElement('style');
    styleEl.id = STYLE_ID;
    styleEl.setAttribute('data-os-report-v2-print', 'true');
    styleEl.textContent = PRINT_PAGE_CSS;
    document.head.appendChild(styleEl);
  }

  const wrapper = document.createElement('div');
  wrapper.id = WRAPPER_ID;
  wrapper.setAttribute('aria-hidden', 'true');
  const clone = rootEl.cloneNode(true);
  if (clone instanceof HTMLElement) {
    clone.removeAttribute('id');
    clone.dataset.printRoot = 'true';
  }
  wrapper.appendChild(clone);
  document.body.appendChild(wrapper);
  document.body.setAttribute(PRINT_FLAG, 'true');

  let cleaned = false;
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    window.removeEventListener('afterprint', cleanup);
    cleanupPrintOsReportV2();
  };

  window.addEventListener('afterprint', cleanup);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      try {
        window.print();
      } catch {
        cleanup();
      }
      window.setTimeout(cleanup, 60_000);
    });
  });
}
